/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 관심표명자에서 사용하는 모달 묶음
 * 버전 : 1.0
 * 파일명 : ModalInterest.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-12-18
 * ================================================================ 
 * 수정일 : 2025-12-26, 강동형 : 업로드 오류 내용 조건문 추가, 데이터가 있을 때 스타일 지정 필요
 * 수정일 : 2026-02-02, 강동형 : 파일 업로드 모달창 연결
 * ================================================================ */

import { useMemo } from "react"
import { AppImage } from "src/assets/images/AppImage"
import styled from "styled-components"

const TitleWrapperInput = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;

    font-size: 18px;
    font-weight: 600;
    color: #000;
`

type Interest_ModalTitle_ErrProps = {
    title : string
}

export const Interest_ModalTitle_Err = ({title}:Interest_ModalTitle_ErrProps)=>{
    return(
        <TitleWrapperInput>
            <AppImage name='AlertCircle'/>
            {title}
        </TitleWrapperInput>
    )
}

const ContentWrapper = styled.div`
    padding: 20px 0px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    font-size: 14px;
    font-weight: 400;
`
const ContentContainer = styled.div`
    padding: 10px;
    border-radius: 5px;
    border: 1px solid #DDD;
`
const Title = styled.div`
    font-weight: 500;
    color: #7F7F89;
`;
const List = styled.div`
    margin: 0px 0 0 18px;
    font-weight: 400;
    color: #7F7F89;
`;
const Item = styled.li`
    list-style: disc;
    margin: 4px 0;
`;

type Interest_ModalContent_ErrProps = {
    data?: any
}

export const Interest_ModalContent_Err = ({data}:Interest_ModalContent_ErrProps) =>{
    const flat = useMemo(() => {
        if (!Array.isArray(data)) return [];

        return data.map((e: any) => ({
            row: e.row,
            col: e.column,
            msg: e.reason,
        }));
    }, [data]);
    
    return data ? (
        <ContentWrapper>
        <span style={{textAlign:'center'}}>
        업로드 규정에 맞지 않아 일부 항목 등록을 실패했습니다.<br/>
        오류 내역을 수정하고 다시 업로드 해주세요.
        </span>
        <Title>오류 내역 (총 {flat.length}개)</Title>
        <ContentContainer>
            <List>
                {flat.map((it, i) => (
                <Item key={`${it.row}-${it.col}-${i}`}>
                    {it.row}행 {it.col}열 - {it.msg}
                </Item>
                ))}
            </List>
        </ContentContainer>
        </ContentWrapper>
    ) : 
    (
        <ContentWrapper style={{textAlign:'center'}}>
            업로드한 엑셀 파일 형식이 올바르지 않습니다.<br/>
            업로드용 엑셀 파일을 확인 후 다시 시도해주세요.
        </ContentWrapper>
    )
}